import { createReducer } from '@reduxjs/toolkit'

import { defaultPage } from 'reducers/ui/defaults'

const initialState = {
    ...defaultPage,
}

export default createReducer(initialState, () => {})
